import type { ISelectOption } from '../../shared/ui/select';
import type { TNotificationCategory, TNotificationChannelCell } from './api';

export const zoneLabel = (zone: string): string => {
  try {
    const parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: zone,
      timeZoneName: 'shortOffset',
    }).formatToParts(new Date());
    const offset = parts.find((part) => part.type === 'timeZoneName')?.value ?? '';
    return offset ? `${zone} · ${offset.replace('GMT', 'UTC')}` : zone;
  } catch {
    return zone;
  }
};

const zones = (): string[] => {
  const supported = Intl.supportedValuesOf?.('timeZone') ?? [];
  return supported.length > 0 ? supported : ['UTC'];
};

// A stored zone the browser does not list still gets a row of its own.
export const zoneOptions = (current: string): ISelectOption<string>[] => {
  const all = zones();
  const list = all.includes(current) ? all : [current, ...all];
  return list.map((zone) => ({ value: zone, label: zoneLabel(zone) }));
};

export { browserZone } from '../../shared/lib/format';

export const cellFor = (
  category: TNotificationCategory,
  channel: 'in_app' | 'email',
): TNotificationChannelCell | undefined =>
  category.channels.find((candidate) => candidate.channel === channel);

export const cellBlock = (cell: TNotificationChannelCell | undefined): string | null => {
  if (!cell) return 'Not sent on this channel.';
  if (!cell.applicable) return 'Not sent on this channel.';
  if (!cell.availableToOrg) {
    return 'This channel isn’t set up yet, so nothing can be sent on it.';
  }
  if (!cell.personalizable) return 'Set for everyone by an owner, above.';
  return cell.locked ? 'An owner turned this off for the whole organization.' : null;
};
